import { cdAxios } from "../../lib/axios";
import { keycloak } from "../../lib/keycloak";
import {
  FindAllUserResponse,
  FindAllUsersFilters,
  UserDTO
} from "./dto";
import { UsersService } from "./service";

export class UsersServiceImpl implements UsersService {
  public findAllUsers(
    filters: FindAllUsersFilters
  ): Promise<FindAllUserResponse> {
    return cdAxios
      .get("/api/users", {
        params: {
          itemsPerPage: filters.itemsPerPage,
          page: filters.page,
          sort: filters.sort,
          order: filters.order,
          role: filters.role,
          search: filters.search?.toLowerCase(),
        },
        headers: {
          Authorization: "Bearer " + keycloak.token,
          Accept: "*/*",
          ContentType: "application/json",
          "Access-Control-Allow-Headers":
            "accept, authorization, content-type, x-requested-with",
          "Access-Control-Allow-Origin": "http://localhost:3000",
          "Access-Control-Allow-Methods": "GET",
        },
      })
      .then((response) => response.data);
  }

  public findUserByUserId(userid: string): Promise<UserDTO> {
    return cdAxios
      .get("/api/users/find/" + userid, {
        headers: {
          Authorization: "Bearer " + keycloak.token,
          Accept: "*/*",
          ContentType: "application/json",
          "Access-Control-Allow-Headers":
            "accept, authorization, content-type, x-requested-with",
          "Access-Control-Allow-Origin": "http://localhost:3000",
          "Access-Control-Allow-Methods": "GET",
        },
      })
      .then((response) => response.data);
  }

  public findMe(): Promise<UserDTO> {
    return cdAxios
      .get("/api/users/find-me", {
        headers: {
          Authorization: "Bearer " + keycloak.token,
          Accept: "*/*",
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.data);
  }
}
